import { render, staticRenderFns } from "./ItemCoupon.vue?vue&type=template&id=6a03678b&scoped=true&"
import script from "./ItemCoupon.vue?vue&type=script&lang=js&"
export * from "./ItemCoupon.vue?vue&type=script&lang=js&"
import style0 from "./ItemCoupon.vue?vue&type=style&index=0&id=6a03678b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a03678b",
  null
  
)

export default component.exports